<template>
  <div class="container-wrap">
    <div id="strategicMap">
    </div>
    <transition name="coll-el">
      <div
        class="context-menu"
        ref="contextMenu"
        v-show="contextMenuVisible"
        v-click-outside="clickMetodEvent"
      >
        <div class="add item" @click="clickMetodEventAddNode">添加</div>
        <div class="add item" @click="clickMetodEventRemove">移除</div>
        <div class="add item" @click="clickMetodEventEdit">编辑</div>
      </div>
    </transition>
    <createDrawer ref="createNodeDrawer" @addNodeComfirm="addNodeComfirm"></createDrawer>
    <el-drawer
      :title="drawerTitle"
      :visible.sync="zbdrawer"
      direction="rtl"
      size="40%"
    >
      <orgZbDrawer v-if="drawerCompontents === 'orgZbDrawer'"></orgZbDrawer>
      <zbDrawer v-if="drawerCompontents === 'zbDrawer'"></zbDrawer>
    </el-drawer>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { onMounted, reactive, ref, watch, getCurrentInstance, nextTick, computed, provide } from '@vue/composition-api'
import { Graph, Dom } from '@antv/x6'
import { initGraphOptions } from '../js/strategicMap/index'
import createDrawer from '../components/strategicMap/createDrawer.vue'
import zbDrawer from '../components/strategicMap/zbDrawer.vue'
import orgZbDrawer from '../components/strategicMap/orgZbDrawer.vue'
import { tree } from '../js/strategicMap/defalutTree'
import '@antv/x6-vue-shape'
import { GridLayout } from '@antv/layout'
import vue from 'vue'
export default {
  name: 'StrategicMap',
  props: [

  ],
  setup () {
    const vm = getCurrentInstance()
    let graph = null
    let source = null
    let target = null
    let contextMenu = ref(null)
    let contextMenuVisible = ref(false)
    let strategicMap = null
    let targetNode = ref({})
    const $createElement = vue.$createElement
    let weakCellLists = new WeakMap()
    let createNodeDrawer = ref()
    //
    let graphOptions = ref({})

    onMounted(() => {
      strategicMap = document.getElementById('strategicMap')
      graph = new Graph({
        container: strategicMap,
        autoResize: true,
        grid: true,
        mousewheel: {
          enabled: true,
          zoomAtMousePosition: true,
          modifiers: 'ctrl',
          minScale: 0.5,
          maxScale: 3
        },
        selecting: {
          enabled: true
          // rubberband: true
        },
        transforming: {
          clearAll: true,
          clearOnBlankMouseDown: true
        },
        translating: {
          restrict: true// 节点移动不能超出画布
        },
        panning: {
          enabled: true
        },
        keyboard: true,
        // resizing: true,
        snapline: true, // 辅助对准线
        connecting: {
          anchor: 'orth'
        },
        interacting: false
      })
      console.log(graph.width, graph.height)
      graphOptions.value = initGraphOptions({ graph })
      graphOptions.value.graphRegisterEdge()
      graphOptions.value.graphRegisterNode()
      graphOptions.value.graphRegisterComponents()

      testNode()
      graph.on('node:contextmenu', (e) => {
        console.log(e)
        console.log(contextMenu.value)
        console.log(e.node.getPorts())
        let x = 10; let y = 10
        // if (e.e.target.nodeName !== 'rect') {
        //   x += e.x
        //   y += e.y
        // } else {
        //   x += e.e.offsetX
        //   y += e.e.offsetY
        // }
        // x += e.e.pageX - e.e.offsetX
        // y += e.e.pageY - e.e.offsetY
        let localPage = graph.localToPage(e.x, e.y)
        console.log(graph.clientToGraph(e.e.clientX, e.e.clientY))
        console.log(e.x)
        console.log(e.y)
        contextMenu.value.style.top = e.e.pageY + 'px'
        contextMenu.value.style.left = e.e.pageX + 'px'
        contextMenuVisible.value = true
        targetNode.value = e.node
      })
      // delete
      graph.bindKey('backspace', () => {
        const cells = graph.getSelectedCells()
        console.log(cells)
        let removeLists = []
        // cells.map(cell => {
        //   console.log(cell.isNode())
        //   if (!cell.isNode()) { removeLists.push(cell) }
        // })
        if (cells.length) {
          graph.removeCells(removeLists)
        }
      })
      // 控制连接桩显示/隐藏
      const showPorts = (ports, show) => {
        for (let i = 0, len = ports.length; i < len; i = i + 1) {
          ports[i].style.visibility = show ? 'visible' : 'hidden'
        }
      }
      graph.on('node:mouseenter', () => {
        const ports = strategicMap.querySelectorAll(
          '.x6-port-body'
        )
        // showPorts(ports, true)
      })
      graph.on('node:mouseleave', () => {
        const ports = strategicMap.querySelectorAll(
          '.x6-port-body'
        )
        showPorts(ports, false)
      })

      graph.on('node:click', (e) => {
        console.log(e)
      })
      // graph.addNode({
      //   x: 40,
      //   y: 40,
      //   width: 200,
      //   height: 40,
      //   shape: 'vue-shape',
      //   component: 'count',
      //   data: {
      //     num: 0
      //   }
      // })
      graph.centerContent()
    })

    function addNodeComfirm ({ options, type }) {
      let { name } = options
      console.log(targetNode.value.position())
      let { x: tx = 0, y: ty = 0 } = targetNode.value.position()
      let node = graphOptions.value.defaultNode({
        y: ty + 50,
        x: tx + 50,
        shape: 'html',
        data: {
          options
        },
        html () {
          const wrap = document.createElement('div')
          // wrap.style.padding = '20px'
          wrap.innerHTML = `
      <h1 class='title-x6'>
        ${name}
      </h1>`
          // setClientWidth(wrap)
          return wrap
        }
      })
      weakCellLists.set(node, { type })
      let target = node
      let source = targetNode.value
      graphOptions.value.createEdge({ target, source })
      targetNode.value = null
    }

    function handleCommand (command) {
      // this.$message('click on item ' + command)
    }
    function clickMetodEvent (command) {
      // this.$message('click on item ' + command)
      contextMenuVisible.value = false
    }
    function clickMetodEventAddNode () {
      console.log(createNodeDrawer)
      createNodeDrawer.value.openDrawer()
    }
    function clickMetodEventRemove () {
      console.log(createNodeDrawer)
      vm.proxy.$confirm('您确定要删除该节点?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    }
    function clickMetodEventEdit () {
      createNodeDrawer.value.openDrawer()
    }
    function setClientWidth ({ Node, dom }) {
      nextTick(() => {
        console.log(dom.clientWidth)
        Node.resize(190, 40)
      })
    }

    let TotalNodes = ref([])
    let TotalEdges = ref([])
    let LayoutEdges = ref([])
    function testNode () {
      let { createEdge, createNode, setNodeOrgChildNode } = graphOptions.value
      let TreeLists = [
        {
          id: 'node1',
          txt: '组织',
          shape: 'html',
          html () {
            const wrap = document.createElement('div')
            // wrap.style.padding = '20px'
            wrap.innerHTML = `
            <h1 class='title-x6'>
              组织
            </h1>`
            // setClientWidth(wrap)
            return wrap
          },
          data: {
            dire: null
          }
        }
      ]

      const orgNodes = [
        createNode('酷开公司', 'Pierre Omidyar'),
        createNode('大内容事业部', 'Devin Wenig'),
        createNode('数字营销事业部', 'Devin Wenig'),
        createNode('电视传媒影视部', 'Devin Wenig'),
        createNode('研发部门', 'Devin Wenig')
      ]

      const edges = [
        createEdge(orgNodes[0], orgNodes[1]),
        createEdge(orgNodes[0], orgNodes[2]),
        createEdge(orgNodes[0], orgNodes[3]),
        createEdge(orgNodes[0], orgNodes[4])
      ]
      LayoutEdges.value.push(...edges)
      TotalEdges.value.push(...edges)
      TotalNodes.value.push(...orgNodes)
      let s = graph.createNode({
        // shape: 'org-node',
        // attrs: {
        //   '.rank': {
        //     text: Dom.breakText(rank, { width: 160, height: 45 })
        //   },
        //   '.name': {
        //     text: Dom.breakText(name, { width: 160, height: 45 })
        //   }
        // }
        x: 230,
        y: 120,
        width: 300,
        height: 200,
        shape: 'vue-shape',
        component: 'count',
        data: {
          num: 0,
          title: '测试',
          nodeType: 1
        }
      })
      let s1 = graph.createNode({
        // shape: 'org-node',
        // attrs: {
        //   '.rank': {
        //     text: Dom.breakText(rank, { width: 160, height: 45 })
        //   },
        //   '.name': {
        //     text: Dom.breakText(name, { width: 160, height: 45 })
        //   }
        // }
        x: 630,
        y: 0,
        width: 300,
        height: 200,
        shape: 'vue-shape',
        component: 'count',
        data: {
          num: 0,
          title: '测试',
          nodeType: 1
        }
      })
      let e1 = createEdge(orgNodes[0], s1)

      graph.resetCells([...TotalNodes.value, ...TotalEdges.value])
      graphOptions.value.layout(TotalNodes.value, LayoutEdges.value)
      console.log(orgNodes[1].getBBox())
      // TotalEdges.value.push()
      let s2 = graph.createNode({
        // shape: 'org-node',
        // attrs: {
        //   '.rank': {
        //     text: Dom.breakText(rank, { width: 160, height: 45 })
        //   },
        //   '.name': {
        //     text: Dom.breakText(name, { width: 160, height: 45 })
        //   }
        // }
        x: 330,
        y: 420,
        width: 300,
        height: 200,
        shape: 'vue-shape',
        component: 'zcardLists',
        data: {
          num: 0,
          title: '测试',
          nodeType: 1
        }
      })
      let s3 = graph.createNode({
        // shape: 'org-node',
        // attrs: {
        //   '.rank': {
        //     text: Dom.breakText(rank, { width: 160, height: 45 })
        //   },
        //   '.name': {
        //     text: Dom.breakText(name, { width: 160, height: 45 })
        //   }
        // }
        x: 530,
        y: 520,
        width: 0,
        height: 0,
        shape: 'vue-shape',
        component: 'graphcanves',
        data: {
          num: 0,
          title: '测试',
          nodeType: 1
        }
      })
      TotalNodes.value.push(s2)
      TotalNodes.value.push(s3)
      let a = setNodeOrgChildNode(orgNodes[0], s2)
      TotalEdges.value.push(a)
      graph.resetCells([...TotalNodes.value, ...TotalEdges.value])
      graphOptions.value.layout(TotalNodes.value, LayoutEdges.value)
      graph.zoomTo(0.8)
      graph.centerContent()
    }

    let zbdrawer = ref(false)
    let drawerTitle = ref('组织')
    let drawerCompontents = ref('')
    // provide('testNode', (node, type) => {
    //   console.log(node, type)
    // })
    vm.proxy.$bus.$on('testNode', (node, type) => {
      zbdrawer.value = true
      drawerCompontents.value = node
      console.log(node, type)
    })
    return {
      drawerCompontents,
      drawerTitle,
      zbdrawer,
      handleCommand,
      contextMenu,
      contextMenuVisible,
      clickMetodEvent,
      clickMetodEventAddNode,
      createNodeDrawer,
      addNodeComfirm,
      clickMetodEventRemove,
      clickMetodEventEdit
    }
  },
  components: {
    createDrawer,
    zbDrawer,
    orgZbDrawer
  },
  directives: {
    ClickOutside
  }
}
</script>

<style scoped lang="stylus">
.container-wrap
  display flex
  width 100%
  height 100%
#strategicMap
  flex 1
.context-menu
  position: absolute
  left: 0
  top: 0
  border-radius:4px
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px 0px;
  background-color: #fff
  .item
    line-height: 36px;
    font-size: 14px;
    color: rgb(96, 98, 102);
    cursor: pointer;
    list-style: none;
    padding: 0px 20px;
    margin: 0px;
    outline: none;
    width 100px
    padding: 0px 20px
    text-align: center
    &:hover
      background-color: rgb(236, 245, 255);
      color: rgb(102, 177, 255);

>>>
  .title-x6
    line-height: 40px
    display: inline-block
    height: 40px
    font-size: 22px
</style>
